import { TableCard } from '../../../../components'
import { FaturaProfissionalListHeader } from './components/header/FaturaProfissionalListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { FaturaProfissionalTable } from './table/FaturaProfissionalTable'

const FaturaProfissionalList = () => {
  return (
    <TableCard>
      <FaturaProfissionalListHeader />
      <FaturaProfissionalTable />
    </TableCard>
  )
}

export const FaturaProfissionalListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <FaturaProfissionalList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
